/**
 * Leads — landing-page contact-form submissions.
 *
 * Public visitors POST to /landing/leads (no auth). Inside the portal,
 * admins (implicit access) and any user the admin has granted `leads`
 * access can browse, mark read, archive, or delete entries.
 */
/** Hard limits the API enforces — mirrored in the UI form. */
export const LEAD_LIMITS = {
    nameMaxLen: 200,
    emailMaxLen: 320,
    phoneMaxLen: 50,
    companyMaxLen: 200,
    subjectMaxLen: 300,
    messageMaxLen: 20_000,
};
//# sourceMappingURL=lead.js.map